module.exports = __webpack_public_path__ + "img/paypal.ad27dc90.png";